export const SMART_CONTRACT_PERCENTAGE_DECIMALS = 18;
